var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.mainLoading,
          expression: "mainLoading",
        },
      ],
      staticClass: "msg-main",
    },
    [
      _c(
        "div",
        { staticClass: "msg-div", attrs: { id: "msg-div" + _vm.nowStr } },
        [
          _c("div", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.tableLoading,
                expression: "tableLoading",
              },
            ],
          }),
          !_vm.tableLoading
            ? _c("div", [
                _vm.loadMore
                  ? _c(
                      "div",
                      {
                        staticClass: "el-table__empty-block",
                        on: { click: _vm.loadingMore },
                      },
                      [
                        _c("span", { staticClass: "el-table__empty-text" }, [
                          _vm._v("点击加载更多"),
                        ]),
                      ]
                    )
                  : _vm._e(),
                !_vm.loadMore
                  ? _c("div", { staticClass: "el-table__empty-block" }, [
                      _c("span", { staticClass: "el-table__empty-text" }, [
                        _vm._v("没有更多了"),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._l(_vm.tableData, function (item) {
            return _c("div", { key: item.id, staticClass: "execution" }, [
              _c(
                "div",
                {
                  staticClass: "avue-comment",
                  class: item.type == "2" ? "avue-comment--reverse" : "",
                },
                [
                  _c("div", { staticClass: "avatar-div" }, [
                    _c("img", {
                      staticClass: "avue-comment__avatar",
                      attrs: {
                        src: item.type == "1" ? item.headimgUrl : item.appLogo,
                      },
                    }),
                    _c("div", { staticClass: "avue-comment__author" }, [
                      _vm._v(
                        _vm._s(item.type == "1" ? item.nickName : item.appName)
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "avue-comment__main" }, [
                    _c("div", { staticClass: "avue-comment__header" }, [
                      _c("div", { staticClass: "avue-comment__create_time" }, [
                        _vm._v(_vm._s(item.createTime)),
                      ]),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "avue-comment__body",
                        style: item.type == "2" ? "background: #6BED72;" : "",
                      },
                      [
                        item.repType == "event" && item.repEvent == "subscribe"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-tag",
                                  { attrs: { size: "mini", type: "success" } },
                                  [_vm._v("关注")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        item.repType == "event" &&
                        item.repEvent == "unsubscribe"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-tag",
                                  { attrs: { size: "mini", type: "danger" } },
                                  [_vm._v("取消关注")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        item.repType == "event" && item.repEvent == "CLICK"
                          ? _c(
                              "div",
                              [
                                _c("el-tag", { attrs: { size: "mini" } }, [
                                  _vm._v("点击菜单"),
                                ]),
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t：【" +
                                    _vm._s(item.repName) +
                                    "】\n\t\t\t\t\t\t"
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        item.repType == "event" && item.repEvent == "VIEW"
                          ? _c(
                              "div",
                              [
                                _c("el-tag", { attrs: { size: "mini" } }, [
                                  _vm._v("点击菜单链接"),
                                ]),
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t：【" +
                                    _vm._s(item.repUrl) +
                                    "】\n\t\t\t\t\t\t"
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        item.repType == "event" &&
                        item.repEvent == "scancode_waitmsg"
                          ? _c(
                              "div",
                              [
                                _c("el-tag", { attrs: { size: "mini" } }, [
                                  _vm._v("扫码结果："),
                                ]),
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t：【" +
                                    _vm._s(item.repContent) +
                                    "】\n\t\t\t\t\t\t"
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        item.repType == "text"
                          ? _c("div", [_vm._v(_vm._s(item.repContent))])
                          : _vm._e(),
                        item.repType == "image"
                          ? _c("div", [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: item.repUrl,
                                    target: "_blank",
                                  },
                                },
                                [
                                  _c("img", {
                                    staticStyle: { width: "100px" },
                                    attrs: { src: item.repUrl },
                                  }),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        item.repType == "voice"
                          ? _c(
                              "div",
                              [
                                _c("WxVoicePlayer", {
                                  attrs: { objData: item },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        item.repType == "video"
                          ? _c(
                              "div",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c("WxVideoPlayer", {
                                  attrs: { objData: item },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        item.repType == "shortvideo"
                          ? _c(
                              "div",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _c("WxVideoPlayer", {
                                  attrs: { objData: item },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        item.repType == "location"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-link",
                                  {
                                    attrs: {
                                      href:
                                        "https://map.qq.com/?type=marker&isopeninfowin=1&markertype=1&pointx=" +
                                        item.repLocationY +
                                        "&pointy=" +
                                        item.repLocationX +
                                        "&name=" +
                                        item.repContent +
                                        "&ref=joolun",
                                      target: "_blank",
                                      type: "primary",
                                    },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          "https://apis.map.qq.com/ws/staticmap/v2/?zoom=10&markers=color:blue|label:A|" +
                                          item.repLocationX +
                                          "," +
                                          item.repLocationY +
                                          "&key=PFFBZ-RBM3V-IEEPP-UH6KE-6QUQE-C4BVJ&size=250*180",
                                      },
                                    }),
                                    _c("p"),
                                    _c("i", {
                                      staticClass: "el-icon-map-location",
                                    }),
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(item.repContent) +
                                        "\n\t\t\t\t\t\t\t"
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        item.repType == "link"
                          ? _c(
                              "div",
                              { staticClass: "avue-card__detail" },
                              [
                                _c(
                                  "el-link",
                                  {
                                    attrs: {
                                      href: item.repUrl,
                                      underline: false,
                                      target: "_blank",
                                      type: "success",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "avue-card__title" },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-link",
                                        }),
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(item.repName) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "avue-card__info",
                                    staticStyle: { height: "unset" },
                                  },
                                  [_vm._v(_vm._s(item.repDesc))]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        item.repType == "news"
                          ? _c(
                              "div",
                              { staticStyle: { width: "300px" } },
                              [
                                _c("WxNews", {
                                  attrs: {
                                    objData: JSON.parse(item.content).articles,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        item.repType == "music"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-link",
                                  {
                                    attrs: {
                                      href: item.repUrl,
                                      underline: false,
                                      target: "_blank",
                                      type: "success",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "avue-card__body",
                                        staticStyle: {
                                          padding: "10px",
                                          "background-color": "#fff",
                                          "border-radius": "5px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "avue-card__avatar" },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: item.repThumbUrl,
                                                alt: "",
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "avue-card__detail" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "avue-card__title",
                                                staticStyle: {
                                                  "margin-bottom": "unset",
                                                },
                                              },
                                              [_vm._v(_vm._s(item.repName))]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "avue-card__info",
                                                staticStyle: {
                                                  height: "unset",
                                                },
                                              },
                                              [_vm._v(_vm._s(item.repDesc))]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]),
                ]
              ),
            ])
          }),
        ],
        2
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.sendLoading,
              expression: "sendLoading",
            },
          ],
          staticClass: "msg-send",
        },
        [
          _c("WxReplySelect", { attrs: { objData: _vm.objData } }),
          _c(
            "el-button",
            {
              staticClass: "send-but",
              attrs: { size: "small", type: "success" },
              on: { click: _vm.sendMsg },
            },
            [_vm._v("发送(S)")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }